import { Typography } from 'antd';
import { omniChatMessages } from 'messages';
import OmniChatSessionAgentList from './OmniChatSessionAgentList';
import { UserCompactDto } from 'types';

type OmniChatSessionWaitingAssignUserProps = {
  onSelectUser?: (id: number, user: UserCompactDto) => void;
  selectedUserId?: number;
  onBack?: () => void;
};

const OmniChatSessionWaitingAssignUser: React.FC<OmniChatSessionWaitingAssignUserProps> = ({
  onSelectUser,
  selectedUserId,
  onBack
}) => {
  return (
    <div className='flex h-full flex-col'>
      <div className='flex h-16 items-center gap-2 px-4'>
        <Typography.Text className='text-lg font-semibold'>{omniChatMessages.chooseDTVToAssign}</Typography.Text>
      </div>
      <div className='max-h-[calc(100%-56px)] overflow-y-auto'>
        <OmniChatSessionAgentList onClickItem={onSelectUser} selectedUserId={selectedUserId} />
      </div>
    </div>
  );
};

export default OmniChatSessionWaitingAssignUser;
